<template>
  <OneColumnTemplate :isOrgSidebar="true" :useUZStyle="true">
    <template v-slot:ColumnContent>
      <div class="PageContentWrapper">
        <div class="ViewContainer">
          <router-link
            to="/org/profile"
            style="text-decoration: none; top: 0px; position: sticky; z-index: 5;"
          >
            <LUUIButtonPrimary ButtonText="Назад" />
          </router-link>

          <span class="Title"> Просмотр заявок</span>

          <div class="MentorsList">
            <div class="GridEvents">
              <div class="GridEl">
                <span class="MentorFIO" style="font-weight: 800;">Номер</span>
                <span class="MentorFIO" style="font-weight: 800;">Дата</span>
                <span class="MentorFIO" style="font-weight: 800;">ФИ </span>
                <span class="MentorFIO" style="font-weight: 800;">Email</span>
                <span class="MentorFIO" style="font-weight: 800;">Телефон</span>
                <span class="MentorFIO" style="font-weight: 800;"
                  >Комментарий</span
                >

                <span class="MentorFIO" style="font-weight: 800;"
                  >Название курса</span
                >
                <span class="MentorFIO" style="font-weight: 800;">Статус</span>
                <span class="MentorFIO" style="font-weight: 800;"
                  >Изменения</span
                >
              </div>

              <div
                class="GridEl"
                v-for="(req, mindx) in requests"
                :key="`mentor-${mindx}-${req?.id}`"
              >
                <span class="MentorFIO">{{ mindx + 1 }}</span>
                <span class="MentorFIO">{{
                  req?.createdAt
                    .split("T")[0]
                    .split("-")
                    .reverse()
                    .join(".")
                }}</span>
                <span class="MentorFIO">{{ req?.surname_name }}</span>
                <span class="MentorFIO">{{ req?.email }}</span>
                <span class="MentorFIO">{{ req?.phone }}</span>
                <span class="MentorFIO">{{ req?.additional }}</span>
                <span class="MentorFIO">{{ req?.Job?.name }}</span>

                <el-select
                  v-model="req.request_status.id"
                  class="OUIElementDefault"
                  popper-class="OUIElementDefault"
                  placeholder="Выберите"
                  size="large"
                  @change="changeRequestStatus(req.id, req.request_status.id)"
                >
                  <el-option
                    v-for="item in statuses"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>

                <LUUIButtonPrimary
                  style="margin: auto 0%;"
                  ButtonText="Просмотр"
                  @click="handleHistories(req?.request_histories || [])"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DefaultModal
        v-show="statusesShow"
        rmtitle="Просмотр статусов"
        rmdesc="Здесь вы можете просмотреть список статусов"
        :handleModalClose="handleCloseModal"
      >
        <template v-slot:FormBody>
          <el-timeline>
            <el-timeline-item
              style="font-family: Open Sans;"
              v-for="(activity, index) in statusesList"
              :key="index"
              :timestamp="activity.timestamp"
            >
              {{ activity.content }}
            </el-timeline-item>
          </el-timeline>
        </template>

        <template v-slot:ButtonsSection>
          <LUUIButtonPrimary
            ButtonText="Закрыть"
            size="big"
            class="ModalButton"
            @click.native="handleCloseModal"
          />
        </template>
      </DefaultModal>
    </template>
  </OneColumnTemplate>
</template>

<script>
import OneColumnTemplate from "@/components/ProfileTemplates/OneColumn.vue";
import DefaultModal from "@/components/DefaultModal";
import LUUIButtonPrimary from "@/components/LevelUpUI/Buttons/primary.vue";

import { QuillEditor } from "@vueup/vue-quill";
import { ElNotification } from "element-plus";

import { mapGetters, mapMutations } from "vuex";
import { findById } from "@/api/user.js";
import { refresh } from "@/api/auth.js";
import { RequestStatuses, RequestList, RequestUpdate } from "@/api/request.js";

export default {
  name: "RequestsList",

  components: {
    OneColumnTemplate,
    QuillEditor,
    LUUIButtonPrimary,
    DefaultModal,
  },

  data() {
    return {
      statuses: [],
      requests: [],

      statusesShow: false,
      statusesList: [],
    };
  },

  async created() {
    if (this.user == null) {
      this.updateUser();
    } else {
      this.getUser(this.user.id);
    }

    await this.initialization();
  },

  methods: {
    async initialization() {
      let respStatuses = await RequestStatuses();
      this.statuses = respStatuses?.data || [];

      let respRequests = await RequestList(this.user.parent_company?.[0]?.id);
      this.requests = respRequests?.data.reverse() || [];

      this.handleCloseModal();
    },

    ...mapMutations("auth", ["SET_USER"]),

    async updateUser() {
      const response = await refresh();
      const userResponse = response.user;
      this.getUser(userResponse.id);
    },

    getUser(id) {
      if (id != undefined) {
        findById(id).then((response) => {
          this.SET_USER(response.data);
        });
      }
    },

    async changeRequestStatus(requestID, newValue) {
      try {
        await RequestUpdate({
          requestID: requestID,
          statusID: newValue,
        });

        await this.initialization();

        ElNotification({
          title: "Успех!",
          message: "Статус заявки изменен",
          type: "success",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      } catch (e) {
        ElNotification({
          title: "Упс!",
          message: "Извините, произошла ошибка на сервере",
          type: "error",
          position: "bottom-right",
          customClass: "ELDefaultNotification",
        });
      }
    },

    handleCloseModal() {
      this.statusesShow = false;
      this.statusesList = [];
    },
    handleHistories(request_histories) {
      this.statusesList = request_histories.map((x) => {
        let date = x.createdAt.split("T")[0];

        return {
          timestamp: date
            .split("-")
            .reverse()
            .join("."),
          content: x.request_status.name,
        };
      });

      this.statusesShow = true;
    },
  },

  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),
  },
};
</script>

<style scoped>
.PageContentWrapper {
  position: relative;
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  gap: 36px;

  width: 100%;

  height: 100%;

  padding-top: 15px;

  overflow: visible;
}

.ViewContainer {
  position: relative;

  margin: 0% auto;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 32px;

  overflow: visible;
}

.Title {
  position: relative;
  display: block;

  min-width: 0px;
  width: 100%;
  height: fit-content;

  font-family: "Open Sans";
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0px;

  color: #000000;
}

.MentorsList {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  justify-content: flex-start;
  gap: 24px;
  flex-wrap: wrap;
}
.GridEvents {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
}
.GridEl {
  position: relative;
  display: grid;

  padding: 12px;

  width: 100%;
  height: fit-content;

  grid-template-columns: repeat(9, 1fr);
  gap: 0% 8px;

  border-bottom: 1px solid gray;
}
.MentorFIO {
  position: relative;
  display: inline;

  margin: auto 0%;

  min-width: 0;
  width: fit-content;
  max-width: 100%;

  height: fit-content;

  font-family: "Montserrat";
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0%;
  text-align: left;

  word-break: break-word;
  word-wrap: break-word;

  color: #000000;
}
.Mentor:hover {
  background-color: #27235c;
}
</style>
